export default "__VITE_ASSET__e9dab799__"